// This file was automatically generated from app.shared.dialog.viewInlinePdf.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.shared.viewInlinePdf');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.viewInlinePdf.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<object class="pdf-holder" data="', (opt_data.pdfUrl) ? soy.$$escapeHtml(opt_data.pdfUrl) : '', '" type="application/pdf" width="100%" height="99%"><embed class="pdf-holder" src="', (opt_data.pdfUrl) ? soy.$$escapeHtml(opt_data.pdfUrl) : '', '" type="application/pdf" width="100%" height="99%" /></object><p class="el8PDFDownloadHelp">Trouble viewing PDF? <a class="download-pdf-trigger">Click here to download.</a></p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.viewInlinePdf.lhsFtueBubble = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FTUEBoxContainer"><a class="el8DialogCloseButton el8CloseButtonHoverWhite bubble-close-trigger"></a><p class="el8FTUEText">This is your own, editable copy of the Clinical Profile. It\'s always here for your quick reference!</p></div><div class="el8FTUEBoxPointerLeft"></div>');
  if (!opt_sb) return output.toString();
};
